import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { AnimatePresence, motion } from 'framer-motion';

const AgoraProvisioningTransition = ({ isOpen, title = 'Inicializando suite profesional...', subtitle = 'Asignando módulos dinámicos de tu identidad.' }) => {
  useEffect(() => {
    if (!isOpen || typeof document === 'undefined') return;

    const body = document.body;
    const currentLocks = Number(body.dataset.overlayLocks || '0');
    body.dataset.overlayLocks = String(currentLocks + 1);
    body.style.overflow = 'hidden';
    body.style.touchAction = 'none';

    return () => {
      const locks = Math.max(0, Number(body.dataset.overlayLocks || '1') - 1);
      if (locks === 0) {
        delete body.dataset.overlayLocks;
        body.style.overflow = '';
        body.style.touchAction = '';
      } else {
        body.dataset.overlayLocks = String(locks);
      }
    };
  }, [isOpen]);

  return createPortal(
    <AnimatePresence>
      {isOpen && (
        <motion.div
          key="provisioning-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35, ease: 'easeOut' }}
          className="fixed top-0 left-0 w-screen h-screen z-[2147483647] bg-black/70 backdrop-blur-[5px] grid place-items-center p-6"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.96, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.97, y: 6 }}
            transition={{ duration: 0.35, ease: 'easeOut' }}
            className="bg-white rounded-2xl shadow-2xl p-8 w-full max-w-md text-center"
          >
            <div className="mx-auto mb-4 w-20 h-20 rounded-full border-4 border-blue-200 border-t-blue-600 animate-spin"></div>
            <h2 className="text-lg font-bold text-gray-900">{title}</h2>
            <p className="text-sm text-gray-600 mt-2">{subtitle}</p>
            <div className="mt-5 inline-flex items-center px-3 py-1 rounded-full bg-blue-50 text-blue-700 text-xs font-semibold">
              Ágora Web · Provisionando
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  );
};

export default AgoraProvisioningTransition;
